import { Adapter as r, getAdapter as e } from "../../../adapter.js";
import { TicketHistoryModel as o } from "./ticketHistory.model.js";
import { TicketHistoryStatusAdapter as i } from "./ticketHistoryStatus/ticketHistoryStatus.adapter.js";
import { TicketHistoryDeliveryAdapter as p } from "./ticketHistoryDelivery/ticketHistoryDelivery.adapter.js";
import { TicketHistoryPosAdapter as s } from "./ticketHistoryPos/ticketHistoryPos.adapter.js";
import { TicketHistoryPaymentAdapter as d } from "./ticketHistoryPayment/ticketHistoryPayment.adapter.js";
import { TicketHistoryRefundAdapter as m } from "./ticketHistoryRefund/ticketHistoryRefund.adapter.js";
class A extends r {
  adapt(t) {
    return new o({
      status: t.status ? e(i).adapt(t.status) : void 0,
      delivery: t.delivery ? e(p).adapt(t.delivery) : void 0,
      pos: t.pos ? e(s).adapt(t.pos) : void 0,
      payment: t.payment ? e(d).adapt(t.payment) : void 0,
      refund: t.refund ? e(m).adapt(t.refund) : void 0
    });
  }
  serialize(t) {
  }
}
export {
  A as TicketHistoryAdapter
};
//# sourceMappingURL=ticketHistory.adapter.js.map
